import { localePath, type Locale } from "@/i18n/locales";

import { landingMagnets, type LandingMagnetKey } from "@/content/landing-magnets";

export type LeadMagnetPromo = {
  href: string;
  eyebrow: string;
  title: string;
  text: string;
  cta: string;
};

const blogSlugToMagnet: Record<string, LandingMagnetKey> = {
  "travel-vaccinations-guide": "travelScan",
  "vaccine-boosters": "boosterReminders",
  "vaccinating-your-children": "vaccinationChecklist",
  "childhood-vaccines-trump-order": "vaccinationChecklist",
  "why-vaccination-records-matter": "vaccinationChecklist",
  "how-mrna-vaccines-work": "vaccinationChecklist",
};

const magnetPaths: Record<LandingMagnetKey, string> = {
  travelScan: "/travel-scan",
  boosterReminders: "/booster-reminders",
  vaccinationChecklist: "/vaccination-checklist",
};

const ctaLabels: Record<Locale, string> = {
  nl: "Bekijk pagina",
  en: "View page",
  de: "View page",
  fr: "View page",
  es: "View page",
};

export function leadMagnetPromoForBlogPost(
  locale: Locale,
  slug: string,
): LeadMagnetPromo | null {
  const magnetKey = blogSlugToMagnet[slug];
  if (!magnetKey) return null;

  const magnet = landingMagnets[locale][magnetKey];

  return {
    href: localePath(locale, magnetPaths[magnetKey]),
    eyebrow: magnet.eyebrow,
    title: magnet.title,
    text: magnet.intro,
    cta: ctaLabels[locale],
  };
}
